import React from 'react';
import { useParams } from 'react-router-dom';
import CallCenter from '../../components/CallCenter';
import Footer from '../../components/Footer';
import Header from '../../components/Header';
import Lnb from '../../components/Lnb';
import Location from '../../components/Location';

type Params = {
    resultCode: string;
}

const PsychlngclCheckAnxietyResult: React.FC = () => {
    const {resultCode} = useParams<Params>();
    const viewResult = (resultCode: string) => {
        switch(resultCode) {
            case "001" :
                return (
                    <>
                        <p className="result">님은 불안 정도가 아주 낮거나 불안을 전혀 느끼지 않고 있습니다. </p>
                        <p>
                            일상생활에서 긴장과 불안은 누구나 느낄 수 있는 정상적인 감정입니다.<br />
                            적당한 긴장과 불안은 오히려 어떤 상황이나 문제에 대처하는데 원동력이 되기도 합니다. <br />
                            어떤 사람들은 보통 수준의 긴장과 불안은 잘 견디지만, 불안과 긴장이 커질 때 혼란을 느끼게 되기도 합니다. 평소 자신의 대처방식을 잘 알고 있지 못했기 때문입니다. <br />
                            스스로에 대해 잘 알고, 어려움에 대해 터놓고 이야기할 수 있는 대상을 가지고 있는 것이 좋습니다.
                        </p>
                        <div className="tip">
                            <p><span>불안에 대처하기 tip</span></p>
                            <ul className="li_common mt20">
                                <li>불안의 원인을 찾아보기</li>
                                <li>원인을 바꿀 수 없다면, 받아들이려 노력하기</li>
                                <li>전문가와의 상담을 통해 불안 다스리기</li>
                            </ul>
                        </div>
                    </>
                )
            case "002" :
                return (
                    <>
                        <p className="result">님은 중간 정도의 불안을 느끼고 있습니다.</p>
                        <p>불안의 정도가 심각하지는 않으나, 가슴이 두근거리거나 손에 땀이 나고, 가슴이나 목이 답답한 느낌이 들거나, 소화가 잘 안되고 불면증이나 두통이 생기는 등의 신체 증상이 나타나기도 합니다. <br/>
                        이런 증상은 불안을 해결해달라는 몸의 신호입니다. 불안의 원인을 확인하고 이에 맞는 대처방안을 생각해보아야 합니다. 불안의 원인은 복합적일 수 있으므로, 혼자서 하기에 어렵다면 전문가의 도움을 받는 것이 좋습니다. 
                        </p>
                        <div className="tip">
                            <p><span>불안에 대처하기 tip</span></p>
                            <ul className="li_common">
                                <li>신체증상이 나타나기 전에 무슨 일이 있었는지 살펴보기</li>
                                <li>불안감이 느껴지면 크게 심호흡하기</li>
                                <li>전문가와의 상담을 통해 불안 다스리기</li>
                            </ul>
                        </div>
                    </>
                )
            case "003" :
                return (
                    <>
                        <p className="result">님은 심한 불안감을 느끼고 있습니다.</p>
						<p>
                            사소한 일에도 심한 불안을 느끼며, 이유 없이 불안을 느끼기도 합니다. 또 땀이 나거나 가슴이 답답하고 숨이 찬 듯한 느낌 등의 신체 증상도 나타납니다. <br/>
                            지나친 불안감은 오히려 실수를 불러일으키고, 실수는 더 큰 불안을 가져오는 악순환으로 연결됩니다. 불안감은 처음에는 특정 영역이나 대상에 대해서만 느껴지다가 점차 생활 전반으로 확대됩니다. 단순히 예민함, 걱정으로 치부하고 그대로 방치하면 일상적인 생활까지 어려워질 수 있습니다. <br />
                            불안감이 심할 때는 전문가의 도움을 받아야 합니다. 불안감을 가져오는 원인을 찾고, 불안이 지속되지 않는 방법을 찾아보면서 불안을 이기는 힘을 길러야 합니다.
                        </p>
                    </>
                )
        }
    }

    return (
        <div id="warp">
            <Header />
            <section id="containers">
                <div className='therapy'>
                    <Lnb />
                    <div id="contents" className='contents'>
                        <h2>무료심리검사</h2>
                        <Location locations={[
                            {title: "토닥토닥마음케어", url: "/column/columnList"}
                            , {title: "무료심리검사", url: "/psychlgclCheck/main"}]} 
                            menuName='불안 자가진단'
                        />
                        <div className='mobileface testing'>
                            <div className="resultWrap nervous">
                                <h3 className="f18 black">불안 자가진단</h3>
                                <h4 className="f14 green mt30">불안 자가진단 결과</h4>
                                <div className="total">
									{
                                        resultCode? (
                                            viewResult(resultCode)
                                        ) : (
                                            viewResult("001")
                                        )
                                    }
								</div>
                                <CallCenter />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default PsychlngclCheckAnxietyResult;